import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import moment from 'moment-mini';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Payment Repair',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/',
      },
      {
        text: 'Payment',
        href: '/adm/opr/payment/repair',
        active: true,
      },
    ],
    form_repair_title: 'Form Payment Repair',
    form_repair_breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/',
      },
      {
        text: 'Payment Repair',
        href: '/adm/opr/payment/repair',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    search: '',
    date_filter: '',
    status_filter: '',
    type_filter: '',
    sortBy: '',
    sortDesc: true,
    fields: [
      {
        key: 'code_payrepair',
        label: 'Payment No',
        sortable: true,
      },
      {
        key: 'created_at',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'doc_type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'B/L No',
        sortable: true,
      },
      {
        key: 'consignee',
        label: 'Consignee',
        sortable: true,
      },
      {
        key: 'total_final',
        label: 'Total',
        sortable: true,
      },
      {
        key: 'payment_type',
        label: 'Status',
        sortable: true,
      },
      {
        key: 'aksi',
      },
    ],
    kwitansi_repair: {},
    detail: false,
    list_payment_repair: [],
    form_repair: {
      typepayment: 'Debit',
      currency: 'IDR',
      payment_type: 'payment',
      code_principle: '',
      doc_no: '',
      consignee: '',
      pkp: '',
      id_pay_repair: '',
      container_info: {},
      container_pay: [],
      pay_reference: [],
      containers: [],
      payment: [],
      total: 0,
      pph23: 0,
      ppn10: 0,
      total_final: 0,
    },
  },
};

export const getters = {
  form_repair(state) {
    return state.data.form_repair;
  },
  kwitansi_repair(state) {
    return state.data.kwitansi_repair;
  },
};

export const mutations = {
  changePayment(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchInterchange(context, params) {
    let result = await ApiGetRequest(`opr/payment-repair/interchange`, params);
    return !result.error ? result.data.object : [];
  },

  async searchBooking(context, params) {
    let result = await ApiGetRequest(`opr/booking`, params);
    return !result.error ? result.data.object : [];
  },

  async getCalculateInterchage({ commit, state }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostRequest(
      `opr/payment-repair/price`,
      payload.form
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      commit('changePayment', {
        form_repair: {
          ...data.form_repair,
          ...result.data.object,
        },
      });

      return result.data.object;
    } else {
      commit('changePayment', {
        form_repair: {
          ...data.form_repair,
          containers: [],
          payment: [],
          total: 0,
          pph23: 0,
          ppn10: 0,
          total_final: 0,
        },
      });
    }

    return false;
  },

  async getCalculateInterchageRefund({ commit, state }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostRequest(
      `opr/payment-repair/${payload.id}/price-refund`,
      payload.form
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      let data_result = result.data.object;
      let container_check = [];
      let container_pay_data = [];

      data_result.container_pay.map((item) => {
        if (container_pay_data.indexOf(item.id_pay_repair_detail) === -1) {
          container_pay_data.push(item.id_pay_repair_detail);
        }
      });

      data_result.containers.map((item) => {
        if (container_check.indexOf(item.id_pay_repair_detail) === -1) {
          container_check.push(item.id_pay_repair_detail);
        }
      });

      let containers = data.form_repair.containers || [];
      containers.map((itemData) => {
        if (container_check.indexOf(itemData.id_pay_repair_detail) === -1) {
          itemData.is_refund = false;
          data_result.containers.push(itemData);
        }
      });

      let container_pay = data.form_repair.container_pay || [];
      container_pay.map((itemData, indexData) => {
        if (container_pay_data.indexOf(itemData.id_pay_repair_detail) !== -1) {
          container_pay[indexData].is_refund = true;
        }
      });

      data_result.container_pay = container_pay;

      commit('changePayment', {
        form_repair: {
          ...data.form_repair,
          ...data_result,
        },
      });

      return result.data.object;
    }

    return false;
  },

  async getListPaymentRepair({ commit, state }) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    if (data.date_filter && data.date_filter.length > 0) {
      params.start_date = data.date_filter[0]
        ? moment(data.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.date_filter[1]
        ? moment(data.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    if (data.type_filter && data.type_filter !== '') {
      params.type_filter = data.type_filter;
    }

    if (data.search_container && data.search_container !== '') {
      params.search_container = data.search_container;
    }

    let result = await ApiGetRequest(`opr/payment-repair`, params);
    commit('changePayment', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async createPaymentRepair({ commit, state, dispatch }) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`opr/payment-repair`, data.form_repair);
    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async updatePaymentRepair({ commit, state, dispatch }) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;

    let result = await ApiPutRequest(
      `opr/payment-repair/${data.detail.id_pay_repair}`,
      data.form_repair
    );
    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async getPaymentRepair({ commit }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    let result = await ApiDeleteRequest(
      `opr/payment-repair/${payload.doc_no}/payment`
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      commit('changePayment', {
        list_payment_repair: result.data.object,
      });

      return true;
    }

    return false;
  },

  async getDetailPaymentRepair({ commit, state }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/payment-repair/${payload.id}`);

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      let resultObj = result.data.object;

      commit('changePayment', {
        form_repair: {
          ...data.form_repair,
          ...resultObj,
          payment_type: data.form_repair.payment_type,
          from_payment: data.form_repair.from_payment,
        },
      });

      return true;
    }

    return false;
  },

  async getInfoPaymentRepair({ commit }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/payment-repair/${payload.id}`);

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      let resultObj = result.data.object;

      commit('changePayment', {
        detail: resultObj,
        form_repair: resultObj,
      });

      return true;
    }

    return false;
  },

  async getBuktiBayarRepair({ commit }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `opr/payment-repair/${payload.id}/kwitansi`
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      commit('changePayment', {
        kwitansi_repair: result.data.object,
      });

      return true;
    }

    return false;
  },

  async getBuktiBayarRepairNotaBaru({ commit }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `opr/payment-repair/${payload.id}/kwitansi-new`
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      commit('changePayment', {
        kwitansi_repair: result.data.object,
      });

      return true;
    }

    return false;
  },
};
